import { AxiosResponse } from 'axios';
import { getAxiosPublicInstance, getAxiosSecureInstance } from '../../utilities/AxiosClient';

export interface PaymentAccount {
  account_name: string;
  stripe_user_id: string;
  type: string;
  stripe_publishable_key: string;
  status: string;
}

export function getPaymentAccounts(organizationId: string | undefined): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(`/api/organizations/${organizationId}/settings/paymentaccounts`);
}

export function updatePaymentAccount(organizationId: string, paymentAccount: PaymentAccount): Promise<AxiosResponse> {
  return getAxiosSecureInstance().put(`/api/organizations/${organizationId}/settings/paymentaccounts`, paymentAccount);
}

export function completeConnect(
  organizationId: string,
  code: string,
  name: string,
  type: string,
  status: string,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(`/api/organizations/${organizationId}/payment/connect`, {
    code,
    name,
    type,
    status,
  });
}

export function revokeConnect(organizationId: string, accountId: string): Promise<AxiosResponse> {
  return getAxiosSecureInstance().delete(`/api/organizations/${organizationId}/payment/connect/${accountId}`);
}

export function getClientSecret(organizationId: string, accountId: string): Promise<AxiosResponse> {
  return getAxiosPublicInstance().get(`/api/organizations/${organizationId}/payment/${accountId}/clientsecret`);
}

export function getPaymentIntentById(
  organizationId: string,
  accountId: string,
  paymentIntentId: string,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().get(
    `/api/organizations/${organizationId}/payment/${accountId}/payment-intent/${paymentIntentId}`,
  );
}

export function refundPaymentById(
  organizationId: string,
  accountId: string,
  paymentIntentId: string,
  formData: FormData,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(
    `/api/organizations/${organizationId}/payment/${accountId}/refund/${paymentIntentId}`,
    formData,
  );
}
export function cancelPaymentIntentById(
  organizationId: string,
  accountId: string,
  paymentIntentId: string,
): Promise<AxiosResponse> {
  return getAxiosSecureInstance().post(
    `/api/organizations/${organizationId}/payment/${accountId}/cancel/${paymentIntentId}`,
  );
}
